import lineChart from './line-chart'

export default {
  components: {
    lineChart
  },
  data() {
    return {}
  }
}
